export default __webpack_public_path__ + "static/media/logo_plie.5c371221.jpeg";